import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { PatientGroupCellComponent } from './patient-group-cell.component';

@NgModule({
  declarations: [PatientGroupCellComponent],
  imports: [CommonModule],
  exports: [PatientGroupCellComponent],
})
export class PatientGroupCellModule {}
